// Where scraper scenarios live in the cabinet. In one place because three things
// link here — the grid, the editor, and the gateway settings form's Scenarios mode — and
// routes.js has to agree with all of them.

export const SCRAPER_SCENARIOS_PATH = '/app/scraper-scenarios';

/** The editor for one scenario; `new` (or no id) for a scenario not yet created. */
export const scenarioEditorPath = (id) => `${SCRAPER_SCENARIOS_PATH}/${id ?? 'new'}`;
